import React from 'react'
import RegistrationDetail from 'src/modules/MyClass/RegistrationDetail'

const RegistrationDetailPage = () => {
  return <RegistrationDetail />
}

export default RegistrationDetailPage
